// extracted by mini-css-extract-plugin
export default {"rotate":"PendingPane_rotate__Qa5KO","rotating":"PendingPane_rotating__gg76h"};